'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { motion, type MotionValue } from 'framer-motion';
import type { RefObject } from 'react';
import { Image } from '@/components/client';
import { ROULETTE_BLANK_IMAGE_SRC } from '../_constants';
import type { RouletteItem } from '../_hooks/useRouletteDetail';
interface RouletteItemStripProps {
  items: RouletteItem[];
  x: MotionValue<number>;
  viewportRef: RefObject<HTMLDivElement | null>;
  isLooping: boolean;
  copyCount: number;
  landedIndex: number | null;
}

//* 업체 JPG는 배경이 칠해져 와서 CORS로 픽셀을 못 읽는다 — 좌상단 모서리를 박스 전체로 늘려 그 색을 깐다.
const EDGE_COLOR_BACKGROUND_SIZE = '10000% 10000%';
export const RouletteItemStrip = t0 => {
  const $ = _c(22);
  const {
    items,
    x,
    viewportRef,
    isLooping,
    copyCount,
    landedIndex
  } = t0;
  let t1;
  if ($[0] !== copyCount || $[1] !== isLooping || $[2] !== items) {
    t1 = isLooping ? Array.from({
      length: copyCount
    }, () => items).flat() : items;
    $[0] = copyCount;
    $[1] = isLooping;
    $[2] = items;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const stripItems = t1;
  const t2 = isLooping ? "overflow-hidden" : "overflow-x-auto";
  let t3;
  if ($[4] !== t2) {
    t3 = cn("hide-scrollbar [-webkit-mask-image:linear-gradient(to_right,transparent,black_48px,black_calc(100%-48px),transparent)] [mask-image:linear-gradient(to_right,transparent,black_48px,black_calc(100%-48px),transparent)] mobile:[-webkit-mask-image:none] mobile:[mask-image:none]", t2);
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== x) {
    t4 = {
      x
    };
    $[6] = x;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== items || $[9] !== landedIndex || $[10] !== stripItems) {
    let t6;
    if ($[12] !== items || $[13] !== landedIndex) {
      t6 = (item, index) => {
        const imageSrc = item.imageUrl ?? (item.blankYN ? ROULETTE_BLANK_IMAGE_SRC : null);
        const isCopy = index >= items.length;
        return <li key={`${Math.floor(index / items.length)}-${item.rouletteItemId}`} aria-hidden={isCopy || undefined} className="flex w-132 shrink-0 flex-col gap-4"><span className={cn("flex h-136 items-center justify-center rounded-xxlarge bg-Gray-white transition-shadow duration-75 motion-reduce:transition-none", index === landedIndex ? "ring-4 ring-inset ring-B-500 xl:ring-0" : "ring-0")} style={imageSrc ? {
            backgroundImage: `url(${imageSrc})`,
            backgroundSize: EDGE_COLOR_BACKGROUND_SIZE,
            backgroundPosition: "0 0"
          } : undefined}>{imageSrc ? <span className="relative size-84"><Image src={imageSrc} alt="" fill={true} sizes="84px" className="object-contain" /></span> : null}</span><span className="line-clamp-2 text-center font-600 text-Gray-900 typo-body3">{item.blankYN ? "\uAF5D" : item.name}</span></li>;
      };
      $[12] = items;
      $[13] = landedIndex;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    t5 = stripItems.map(t6);
    $[8] = items;
    $[9] = landedIndex;
    $[10] = stripItems;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = <motion.ul style={t4} className="w-max flex gap-12 px-24 mobile-tablet:px-20">{t5}</motion.ul>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t3 || $[19] !== t6 || $[20] !== viewportRef) {
    t7 = <div ref={viewportRef} className={t3}>{t6}</div>;
    $[18] = t3;
    $[19] = t6;
    $[20] = viewportRef;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
};